import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "react-recompose";
import get from "lodash/get";
import { dailyQuestActions } from "../../../store/actions";
import IconCorrect from "../../../static/images/IconCorrect.svg";
import IconWrong from "../../../static/images/IconWrong.svg";
import OpenTPIcon from "../../../static/images/OpenTPIcon.svg";

const QuestResult = ({ t, dailyQuest, viewTouchPoint, goToHome, client }) => {
  const { isCorrect, strikes, questPoints, description } = get(dailyQuest, "questAnswer", {});
  return (
    <div className={`quest-content result ${isCorrect ? "correct" : "wrong"}`}>
      <img src={isCorrect ? IconCorrect : IconWrong} alt="" />
      <div className="quest-result-info">
        <div className="result-message">
          {t(`dailyQuest.${isCorrect ? "correctAnswerText" : "wrongAnswerText"}`, {
            lblStatuspoints: client?.ranking?.lblStatuspoints,
          })}
        </div>
        {strikes > 2 && <div className="streak-message">{t("dailyQuest.daysInStreak", { strikes: strikes })}</div>}
        <div className="points-message">
          {t("dailyQuest.countedPoints", { count: questPoints, lblStatuspoints: client?.ranking?.lblStatuspoints })}
        </div>
      </div>
      <div className="result-buttons">
        <div className="open-tp-btn" onClick={viewTouchPoint}>
          <img src={OpenTPIcon} alt="" />
          <div className="btn-title">{t("dailyQuest.viewTP", { lblTouchPoint: client?.lblTouchPoint })}</div>
        </div>
        <div onClick={goToHome} className="ok-btn">
          {t("dailyQuest.ok")}
        </div>
      </div>
      {description && (
        <div className="explanation">
          <div className="explanation-title">{t("dailyQuest.explenationTitle")}</div>
          <div className="explanation-text">{description}</div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  dailyQuest: state.dailyQuest,
  client: state.client.client,
});

export default compose(connect(mapStateToProps, dailyQuestActions))(withTranslation()(QuestResult));
